// Site colour theme. Dark burgundy by default; `?tema=acik` switches to light,
// `?tema=bordo` back to dark; the choice is remembered per visitor.
const KEY = 'lucien-tema';

export const initTheme = () => {
  let tema = null;
  try {
    const q = new URLSearchParams(window.location.search).get('tema');
    if (q === 'bordo' || q === 'acik') localStorage.setItem(KEY, q);
    tema = localStorage.getItem(KEY);
  } catch { /* storage unavailable: default theme */ }
  if (tema !== 'acik') document.documentElement.dataset.tema = 'bordo';
  else delete document.documentElement.dataset.tema;
};

export const isBordo = () => document.documentElement.dataset.tema === 'bordo';
